import API_URL from "@packages/lib/server-actions/api-urls";
import { fetchWithCache } from "@packages/lib/server-actions/optimizedsearch";
import { getProjectSpecificData } from "@packages/lib/utlils/commonFunction";

export function getInYearAjax(
  type: "SUBJECT" | "INSTITUTION" = "SUBJECT",
  isClearingEnabled = false
) {
  const payLoad: any = {
    affiliateId: 220703,
    keyword: "",
    qualCode: "",
    networkId: 2,
    pageName: "homepage",
  };
  const queryParamsSubject = new URLSearchParams({
    ...payLoad,
    actionType: "subject",
  }).toString();
  const queryParamsUni = new URLSearchParams({
    ...payLoad,
    actionType: "institution",
    clearingFlag: isClearingEnabled,
  }).toString();
  return fetchWithCache({
    url: process.env.NEXT_PUBLIC_BFF_API_DOMAIN + API_URL?.subjectAjax,
    method: "GET",
    queryParams: type === "SUBJECT" ? queryParamsSubject : queryParamsUni,
  });
}

export function getClearingAjax() {
  return fetchWithCache({
    url:
      process.env.NEXT_PUBLIC_DOMSERVICE_API_DOMAIN +
      API_URL?.clearingSubjectAjax,
    method: "GET",
    queryParams: new URLSearchParams({
      affiliateId: getProjectSpecificData("affiliateId"),
      pageName: "homepage",
    }).toString(),
    isDomServiceBff: true,
  });
}
